const React = require("react");
const T = require("prop-types");
const RaisedButton = require("material-ui/RaisedButton").default;
const TextField = require("material-ui/TextField").default;
const IsEmail = require("utils/is-email");
const Paper = require("material-ui/Paper").default;

const internals = {};

internals.paperStyle = {
    padding: "3rem",
    margin: "4rem 0"
};

internals.labelStyle = {
    textTransform: "inherit"
};

module.exports = class PasswordReset extends React.Component {
    static propTypes = {
        onSubmit: T.func.isRequired,
        match: T.object
    };

    constructor() {
        super();

        this.state = {
            email: "",
            confirmEmailHasBlurred: false,
            password: "",
            confirmPassword: "",
            confirmPasswordHasBlurred: false
        };

        this.emailChanged = this._emailChanged.bind(this);
        this.passwordChanged = this._passwordChanged.bind(this);
        this.confirmEmailBlurred = this._confirmEmailBlurred.bind(this);
        this.confirmPasswordBlurred = this._confirmPasswordBlurred.bind(this);
        this.confirmPasswordChanged = this._confirmPasswordChanged.bind(this);
        this.submit = this._submit.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    _emailChanged(ev) {
        this.setState({ email: ev.target.value });
    }

    _passwordChanged(ev) {
        this.setState({ password: ev.target.value });
    }

    _confirmEmailBlurred() {
        if (!this.state.confirmEmailHasBlurred) {
            this.setState({ confirmEmailHasBlurred: true });
        }
    }

    _confirmPasswordBlurred() {
        if (!this.state.confirmPasswordHasBlurred) {
            this.setState({ confirmPasswordHasBlurred: true });
        }
    }

    _confirmPasswordChanged(ev) {
        this.setState({ confirmPassword: ev.target.value });
    }

    _submit(ev) {
        const { email, password } = this.state;

        const resetToken = this.props.match.params.token;

        this.props.onSubmit(email, password, resetToken);
        ev.preventDefault();
    }

    render() {
        const {
            email,
            confirmEmailHasBlurred,
            password,
            confirmPassword,
            confirmPasswordHasBlurred
        } = this.state;

        const passwordsMatch = password === confirmPassword;
        const error =
            confirmPasswordHasBlurred &&
            (password || confirmPassword) &&
            !passwordsMatch;
        const emailError =
            confirmEmailHasBlurred && (email === "" || !IsEmail(email));

        return (
            <Paper style={internals.paperStyle}>
                <form onSubmit={this.submit}>
                    <h2>Reset Password</h2>
                    <div>
                        Please confirm your email and set your new password.
                    </div>
                    <div className="form-group">
                        <TextField
                            type="email"
                            floatingLabelText="joe@example.com"
                            onChange={this.emailChanged}
                            onBlur={this.confirmEmailBlurred}
                            value={email}
                            errorText={emailError && "Please enter your email"}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            type="password"
                            floatingLabelText="Password"
                            onChange={this.passwordChanged}
                            value={password}
                        />
                    </div>
                    <div className="form-group">
                        <TextField
                            type="password"
                            floatingLabelText="Confirm Password"
                            onBlur={this.confirmPasswordBlurred}
                            onChange={this.confirmPasswordChanged}
                            value={confirmPassword}
                            errorText={error && "Passwords do not match"}
                        />
                    </div>
                    <div>
                        <RaisedButton
                            primary
                            disabled={
                                !password || !passwordsMatch || emailError
                            }
                            label="Update Password"
                            onClick={this.submit}
                            type="submit"
                            labelStyle={internals.labelStyle}
                        />
                    </div>
                </form>
            </Paper>
        );
    }
};



// WEBPACK FOOTER //
// ./src/routes/password-reset/components/PasswordReset.js